import SaleList from './SaleList'
import SaleDetail from './SaleDetail'

const sales = {
    list : SaleList,
    show: SaleDetail
}

export default sales